<template lang="pug">
	.form-row
		.form-col.form-col--label
			slot(name="label", :id="id")
		.form-col.form-col--input
			slot(name="input", :id="id")
</template>
<script>
export default {
	name: 'FormRow',
	data: () => ({
		id: {
			input: 'sf_valform-fr-'
		}
	}),
	provide() {
		this.id.input = `${this.id.input}${this._uid}`;
		this.id.error = `${this.id.input}-err`;
		this.id.tooltip = `${this.id.input}-tooltip`;
		this.id.addon = `${this.id.input}-addon`;
		return {
			providedInputId: this.id.input,
			providedErrorId: this.id.error,
			providedTooltipId: this.id.tooltip,
			providedAddonId: this.id.addon
		};
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '~@sfui/helpers/_queries';

.form-col--label {
	@media screen and ($tablet) {
		flex: 0 0 180px;
	}

	@media screen and ($desktop) {
		flex: 0 0 240px;
	}
}

.form-col--input {
	@media screen and ($tablet) {
		align-items: center;
		display: flex;
	}
}

.form-col--input .vue-radio-group {
	@media screen and ($mobile-only) {
		margin-top: 20px;
	}
}
</style>
